import { httpGet, httpPost } from './request'

export const getTracesInfo = () => {
  return httpGet({
    url: '/v1/traces/env',
  })
}

export function apiGetAppliedSkinConfig(data: {
  domainUrl: string,
}) {
  return httpGet({
    url: `${window.location.origin}/icrc-api/skin/config/product/getAppliedSkinConfig`,
    data
  })
}

export const apiLogin = (data: {
  username: string,
  password: string,
}) => {
  return httpPost({
    url: '/ikg/login',
    data
  })
}

export function getAppConfig(data: any) {
  return httpPost({
    url: `${window.location.origin}/icrc-api/sys/config/getConfig`,
    data
  })
}